import { cnpj, cpf } from 'cpf-cnpj-validator';

const CPF_LENGTH = 11;
const CNPJ_LENGTH = 14;

type DocumentValue = string | number | null | undefined;

const toString = (value: DocumentValue) => String(value ?? '');

const cleanCpf = (value: DocumentValue) => cpf.strip(toString(value)).substring(0, CPF_LENGTH);

export const cleanCnpj = (value: DocumentValue) => cnpj.strip(toString(value)).substring(0, CNPJ_LENGTH);

const isCnpjDocument = (value: DocumentValue) => {
  const normalized = toString(value);

  return /[a-z]/i.test(normalized) || cnpj.strip(normalized).length > CPF_LENGTH;
};

export const cleanCpfAndCnpj = (value: DocumentValue) => (isCnpjDocument(value) ? cleanCnpj(value) : cleanCpf(value));

const formatCpf = (value: DocumentValue) => cpf.format(cleanCpf(value));

export const formatCnpj = (value: DocumentValue) => cnpj.format(cleanCnpj(value));

export const formatCpfAndCnpj = (value: DocumentValue) =>
  isCnpjDocument(value) ? formatCnpj(value) : formatCpf(value);

export const validateCpfAndCnpj = (value: string) => cnpj.isValid(value) || cpf.isValid(value);
